import { m } from '../i18n';
import { h } from './dom';
import { closePanel, openPanel } from './panel';
import { todayBlock } from './journal';

export interface DaySummary {
  day: string;
  stars: number;
  goalsDone: number;
  goalsTotal: number;
  choresDone: number;
  choresTotal: number;
  collapses: number;
  mood: number;
  momLove: number;
  weekEnd: boolean;
  week: number;
  totalStars: number;
}

export function rankFor(stars: number): number {
  return stars >= 260 ? 3 : stars >= 180 ? 2 : stars >= 110 ? 1 : 0;
}

export function showSummary(d: DaySummary, next: () => void): void {
  const goNext = () => {
    closePanel('summary');
    if (d.weekEnd) showWeek(d, next);
    else next();
  };
  openPanel('summary', () => {
    const t = m().summary;
    const row = (label: string, value: string, good?: boolean) =>
      h('div', { class: `stat-row${good === undefined ? '' : good ? ' good' : ' bad'}` }, h('span', null, label), h('b', null, value));
    return {
      title: `🌙 ${t.title(d.day)}`,
      className: 'summary',
      closable: false,
      body: [
        h('div', { class: 'summary-stars' }, `⭐ +${Math.max(0, d.stars)}`),
        row(t.goals, `${d.goalsDone}/${d.goalsTotal}`, d.goalsDone === d.goalsTotal),
        row(t.chores, `${d.choresDone}/${d.choresTotal}`, d.choresDone >= 4),
        row(t.collapses, String(d.collapses), d.collapses === 0),
        row(t.mood, `${d.mood}`, d.mood >= 50),
        row(t.momLove, `${d.momLove}`, d.momLove >= 60),
        // Growth record: what happened today (classroom package).
        todayBlock(),
      ],
      footer: [h('button', { class: 'btn gold', onclick: goNext }, t.next)],
    };
  });
}

function showWeek(d: DaySummary, next: () => void): void {
  openPanel('week', () => {
    const t = m().summary;
    const rank = t.ranks[rankFor(d.totalStars)];
    return {
      title: `🏆 ${t.weekTitle(d.week)}`,
      className: 'summary',
      closable: false,
      body: [h('div', { class: 'summary-stars' }, `⭐ ${d.totalStars}`), h('p', { class: 'center' }, t.weekText(d.totalStars, rank))],
      footer: [
        h(
          'button',
          {
            class: 'btn gold',
            onclick: () => {
              closePanel('week');
              next();
            },
          },
          t.nextWeek,
        ),
      ],
    };
  });
}
